/** @file Animation index by exact name, or NOT_FOUND at the given input path. */
import type { SkeletonData } from '../skeletonData';
import { coreFail } from './coreFail';

/** data.animationIndex lookup; throws NOT_FOUND (kind 'animation', ref = name) at `path` when absent. */
export function findAnimation(data: SkeletonData, name: string, path: string): number {
  return data.animationIndex.get(name) ?? coreFail('NOT_FOUND', `animation "${name}" not found`, { params: { kind: 'animation', ref: name }, path });
}
